import React from 'react';

function BMITable({ classification }) {
    return (
        <table>
            <thead>
                <tr>
                    <th>Indeks Massa Tubuh (IMT)</th>
                    <th>Status Gizi</th>
                </tr>
            </thead>
            <tbody>
                <tr className={classification === 'Underweight' ? 'highlightedWarning' : ''}>
                    <td>Kurang dari 18,5</td>
                    <td>Berat badan kurang (Underweight)</td>
                </tr>
                <tr className={classification === 'Normal weight' ? 'highlightedOk' : ''}>
                    <td>18,5–24,9</td>
                    <td>Berat badan normal (Normal weight)</td>
                </tr>
                <tr className={classification === 'Pre-obesity' ? 'highlightedWarning' : ''}>
                    <td>25,0–29,9</td>
                    <td>Kelebihan berat badan (Pre-obesity)</td>
                </tr>
                <tr className={classification === 'Obesity class I' ? 'highlightedDanger' : ''}>
                    <td>30,0–34,9</td>
                    <td>Obesitas tingkat I (Obesity class I)</td>
                </tr>
                <tr className={classification === 'Obesity class II' ? 'highlightedDanger' : ''}>
                    <td>35,0–39,9</td>
                    <td>Obesitas tingkat II (Obesity class II)</td>
                </tr>
                <tr className={classification === 'Obesity class III' ? 'highlightedDanger' : ''}>
                    <td>40 atau lebih</td>
                    <td>Obesitas tingkat III (Obesity class III)</td>
                </tr>
                <tr>
                    <td colSpan="2">
                        <b>Sumber:</b>{' '}
                        <a href="https://www.who.int/europe/news-room/fact-sheets/item/a-healthy-lifestyle---who-recommendations">
                            Organisasi Kesehatan Dunia (WHO)
                        </a>
                    </td>
                </tr>
                <tr>
                    <td colSpan="2">
                        <b>Terakhir diperbarui:</b> 28/02/2026
                    </td>
                </tr>
            </tbody>
        </table>
    );
}

export default BMITable;
